import { evidenceDiaryDetailSearchFields } from '../../../../common/forms/evidenceDiary/fields'
import { denormalizeDecimalFields } from '../../../../utils/general'
import { Criteria, filterEmptyDetailSearchValues } from '../utils'

// Denormalizes comma-formatted price fields to dot-decimal to match the API's criteria contract.
export const transformEvidenceDiaryDetailSearchCriteria = (values: Criteria): Criteria => {
    const filteredValues = filterEmptyDetailSearchValues(values)

    return {
        ...filteredValues,
        ...denormalizeDecimalFields(filteredValues, [evidenceDiaryDetailSearchFields.PRICE_FROM, evidenceDiaryDetailSearchFields.PRICE_TO]),
    }
}
